import { createChart, ColorType } from 'lightweight-charts';
import React, { useEffect, useRef } from 'react';

interface ChartComponentProps {
  data: { time: any; value: any }[];
  colors?: {
    backgroundColor?: string;
    lineColor?: string;
    textColor?: string;
    areaTopColor?: string;
    areaBottomColor?: string;
  };
  handleZoomFunction: (newValue: any) => void;
  handleDragFunction: (newValue: any) => void;
}

const ChartComponent: React.FC<ChartComponentProps> = (props) => {
  const {
    data,
    colors: {
      backgroundColor = 'white',
      lineColor = '#2962FF',
      textColor = 'black',
      areaTopColor = '#2962FF',
      areaBottomColor = 'rgba(41, 98, 255, 0.28)',
    } = {},
    handleZoomFunction,
    handleDragFunction,
  } = props;

  const chartContainerRef = useRef<any>(null);
  const debounceTimeoutRef = useRef<any>(null);

  useEffect(() => {
    const handleResize = () => {
      if (chartContainerRef.current) {
        chart.applyOptions({ width: chartContainerRef.current.clientWidth });
      }
    };

    if (!chartContainerRef.current) {
      return;
    }

    const chart = createChart(chartContainerRef.current, {
      layout: {
        background: { type: ColorType.Solid, color: backgroundColor },
        textColor,
      },
      // width: chartContainerRef.current.clientWidth,
      // height: chartContainerRef.current.clientHeight,
      timeScale: {
        timeVisible: true, // Show time labels
        secondsVisible: true, // Hide seconds if not needed
      },
    });

    // chart.timeScale().subscribeVisibleTimeRangeChange((e) => {
    //     const visibleRange = chart.timeScale().getVisibleRange();
    //     console.log('Zoom changed', visibleRange);
    //     handleZoomFunction(visibleRange)
    // });

    // Handle drag
    const handleMouseDown = () => {
      console.log('Drag started');
      const handleMouseUp = () => {
        console.log('Drag ended');
        handleDragFunction('Drag ended');
        document.removeEventListener('mouseup', handleMouseUp);
      };
      document.addEventListener('mouseup', handleMouseUp);
    };

    chartContainerRef.current.addEventListener('mousedown', handleMouseDown);

    chart.timeScale().fitContent();
    chartContainerRef.current.addEventListener(
      'wheel',
      (event: { preventDefault(): unknown; deltaY: number }) => {
        event.preventDefault(); // Prevent the default zoom behavior

        // Clear the previous debounce timeout
        if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
        }

        // Check if the event is zooming in or zooming out
        if (event.deltaY < 0) {
          // console.log('Zoom in detected');
          // handleZoomFunction('Zoom in detected');
        } else if (event.deltaY > 0) {
          // console.log('Zoom out detected');
          // handleZoomFunction('Zoom out detected');
        }
        // Set a new debounce timeout
        debounceTimeoutRef.current = setTimeout(() => {
          handleZoomFunction('Zoom end detected');
        }, 300); // Adjust the delay as needed
      },
    );

    const newSeries = chart.addAreaSeries({
      lineColor,
      topColor: areaTopColor,
      bottomColor: areaBottomColor,
    });
    newSeries.setData(data);

    window.addEventListener('resize', handleResize);

    return () => {
      chartContainerRef?.current?.removeEventListener(
        'mousedown',
        handleMouseDown,
      );
      window.removeEventListener('resize', handleResize);

      chart.remove();
    };
  }, [
    data,
    backgroundColor,
    lineColor,
    textColor,
    areaTopColor,
    areaBottomColor,
  ]);

  return <div ref={chartContainerRef} className="chart-container" />;
};

const MemoizedComponent = React.memo(ChartComponent);
export default MemoizedComponent;
